function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 12.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "wallet icon",
    d: "M376.307 619a21.216 21.216 0 0 0-2.2.064 1.991 1.991 0 0 0-2.044 2.046 3.381 3.381 0 0 0-.062.968v6.154a3.369 3.369 0 0 0 .064.97 1.991 1.991 0 0 0 2.046 2.044 21.326 21.326 0 0 0 2.2.063h7.385a21.194 21.194 0 0 0 2.2-.064 1.991 1.991 0 0 0 2.044-2.046 3.381 3.381 0 0 0 .063-.967v-6.154a3.372 3.372 0 0 0-.064-.97 1.991 1.991 0 0 0-2.046-2.044 21.326 21.326 0 0 0-2.2-.062zm0 1.231h7.385c.92 0 1.6 0 2.061.055a.826.826 0 0 1 .96.959 2.359 2.359 0 0 1 .055.832v.615h-2.461a.617.617 0 0 0-.135.013 2.451 2.451 0 0 0 0 4.9.613.613 0 0 0 .135.013h2.461v.615a2.362 2.362 0 0 1-.055.831.826.826 0 0 1-.959.96c-.459.052-1.141.055-2.062.055h-8v-9.837h.615zm-1.846.043v9.759c-.065 0-.158-.005-.215-.012a.826.826 0 0 1-.96-.959 2.359 2.359 0 0 1-.055-.832v-6.154a2.359 2.359 0 0 1 .055-.831.826.826 0 0 1 .959-.96c.058-.006.151-.007.216-.012zm9.846 3.649h2.461v2.461h-2.461a1.231 1.231 0 1 1 0-2.461zm0 .615a.615.615 0 1 0 .615.615.615.615 0 0 0-.615-.615z",
    transform: "translate(-372 -619)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedWalletIcon);
export default __webpack_public_path__ + "static/media/detailed-wallet-icon.ba5aeb441447125fc2da31dfc2c63a7d.svg";
export { ForwardRef as ReactComponent };